import { fetchAuthSession } from "aws-amplify/auth";
import { generateClient } from "aws-amplify/api";

const client = generateClient();
  
export async function gql(query, variables) {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();

    const res = await client.graphql({
        query, 
        variables,
        authToken: idToken
    });
    if (res.errors?.length) throw new Error(res.errors[0].message);
    return res.data;
}